import { ISupplier } from 'types';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SupplierInformation',

  props: {
    supplierData: {
      type: Object as () => ISupplier,
      required: true,
    },
  },
});
